import WebpackerReact from 'webpacker-react'
import CsrTeamMembersIndex from '../react/CsrTeamMembersIndex'
import CsrFilter from '../components/CsrFilter'
import ChevronToggle from '../components/ChevronToggle'
import CsrSortableTeamMembersList from '../react/CsrSortableTeamMembersList'

export default class TeamMembers {
  constructor(params) {
    WebpackerReact.setup({CsrTeamMembersIndex})
    this.params = params;
    this.role = params.role || "csr";
  }

  index() {
    this.csrFilter = new CsrFilter({selector: "#filter-csr-rep"});
    this.initializeListView();
  }

  show() {
    new ChevronToggle();
  }

  initializeListView() {
    let data = $(".js-csr-team-members-react-data").data("reactProps").jobs;
    let list = new CsrSortableTeamMembersList({
      sortScope: `#sort-filters-csr-team-members`,
      selector: `.js-csr-team-members-table`,
      data: data,
      roleType: this.role
    });
    this.csrFilter.addList('team', data, list)
    list.render()
  }
}
